export default {
  cargoLoadType: 'Cargo',
  furnitureLoadType: 'Furniture',
  postageLoadType: 'Postage',
  clientTypes: {
    WEB: 'Website',
    WEB_ADMIN: 'Website - admin panel',
    WEB_COMPANY: 'Website - courier panel',
    WEB_DRIVER: 'Website - driver panel',
    DESKTOP: 'Desktop',
    ANDROID: 'Android',
    ANDROID_PWA: 'Android (PWA)',
    ANDROID_WEB_VIEW: 'Android (WebView)',
    ANDROID_ADMIN: 'Android - admin panel',
    ANDROID_ADMIN_PWA: 'Android - admin panel (PWA)',
    ANDROID_ADMIN_WEB_VIEW: 'Android - admin panel (WebView)',
    ANDROID_COURIER: 'Android - courier',
    ANDROID_COURIER_PWA: 'Android - courier (PWA)',
    ANDROID_COURIER_WEB_VIEW: 'Android - courier (WebView)',
    ANDROID_DRIVER: 'Android - driver',
    ANDROID_DRIVER_PWA: 'Android - driver (PWA)',
    ANDROID_DRIVER_WEB_VIEW: 'Android - driver (WebView)',
    IOS: 'IOS',
    IOS_PWA: 'IOS (PWA)',
    IOS_WEB_VIEW: 'IOS (WebView)'
  },
  pricingTypes: {
    courierTariff: 'Courier tariff',
    auction: 'auction',
    webservice: 'Webservice',
    systemTariff: 'System tariff'
  },
  loadTypes: {
    furniture: 'Furniture',
    cargo: 'Cargo',
    postalPostage: 'Postal postage',
    delivery: 'Delivery',
    pickup: 'Pickup',
    material: 'Material',
    trash: 'Trash',
    freight: 'Freight'
  },
  loadRanges: {
    urban: 'Urban',
    intercity: 'Intercity'
  },
  loadStates: {
    pricingPending: 'pricing pending',
    acceptPending: 'accept pending',
    confirmed: 'Confirmed',
    started: 'Started',
    finished: 'Finished'
  },
  os: {
    windows: 'WINDOWS',
    mac: 'MAC',
    linux: 'LINUX',
    android: 'ANDROID',
    apple: 'APPLE',
    unix: 'UNIX',
    undefined: 'UNDEFINED'
  },
  financial: {
    reject: 'reject',
    draft: 'draft',
    pending: 'pending',
    approved: 'approved',
    general: 'general',
    limit: 'limit',
    paid: 'paid',
    didntPay: "didn't pay"
  },
  opinion: {
    reject: 'Reject',
    pending: 'Pendding',
    inProgress: 'Inprogress',
    approved: 'Approved',
    cons: 'cons',
    pros: 'pros'
  },
  message: {
    unicast: 'Unicast',
    multicast: 'Multicast',
    broadcast: 'Broadcast'
  },
  dictionary: {
    city: 'City',
    province: 'Province',
    chapar: 'Chapar',
    mahex: 'Mahex',
    postex: 'Postex',
    dictionary: 'Dictionary',
    webservice: 'Webservice'
  },
  days: {
    saturday: 'Saturday',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wendesday: 'Wendesday',
    thursday: 'Thursday',
    friday: 'Friday'
  },
  log: {
    report: 'Report',
    detail: 'Detail',
    index: 'Index',
    export: 'Export',
    instantiate: 'Instantiate',
    editImage: 'Edit image',
    create: 'Create',
    update: 'Edit',
    delete: 'Delete',
    generate: 'Generate',
    import: 'Import',
    upsert: 'Upsert',
    logicalDelete: 'Logical Delete',
    enable: 'Enable',
    disable: 'Disable',
    patch: 'Patch'
  },
  reasonType: {
    cancelOrder: 'Cancel order',
    suspendAccount: 'Suspend account',
    deleteAccount: 'Delete account',
    courierBlackList: 'Courier black list',
    driverBlackList: 'Driver black list',
    failDelivery: 'Fail delivery'
  },
  priority: {
    unknown: 'Unknown',
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    urgent: 'Urgent'
  },
  plateType: {
    car: 'Car',
    motorcycle: 'Motorcycle'
  },
  fuelType: {
    petrol: 'Petrol',
    gasoline: 'Gasoline'
  },
  weather: {
    rainy: 'Rainy',
    snowy: 'Snowy',
    foggy: 'Foggy',
    frost: 'Frost'
  },
  educationLevel: {
    primarySchool: 'primarySchool',
    middleSchool: 'middleSchool',
    diploma: 'diploma',
    associate: 'associate',
    bsc: 'bsc',
    msc: 'msc',
    phd: 'phd',
    postdoc: 'postdoc'
  },
  openBankingPaymentTransferStatus: {
    waitForCustomerAccept: 'Wait for customer accept',
    waitForBranchAccept: 'Wait for branch accept',
    branchReject: 'Branch reject',
    readyToTransfer: 'Ready to transfer',
    suspend: 'Suspend',
    cancel: 'Cancel',
    processed: 'Processed'
  },
  openBankingPaymentType: {
    normal: 'Normal',
    ach: 'ACH',
    rtgs: 'RTGS'
  }
}
